import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { formatCost, formatUnixDate } from '@/shared/lib/datetime';
import { useRouteId } from '@/shared/lib/useRouteId';
import { DataTable, type DataColumn } from '@/shared/ui/DataTable';
import { DetailLayout } from '@/shared/ui/DetailLayout';
import { fetchOrderParts, fetchPartOrder, type OrderPart, type PartOrder } from './api';

const rub = (value: number | string | undefined) => `${formatCost(value)} ₽`;

const ORDER_COLUMNS: DataColumn<PartOrder>[] = [
  { header: 'Дата', render: (o) => formatUnixDate(o.create_time) },
  { header: 'Пункт самовывоза', render: (o) => o.delivery_address },
  { header: 'ФИО клиента', render: (o) => o.customer_name },
  { header: 'ID заказчика', render: (o) => <Link to={`/users/user/${o.user_id}`}>{o.user_id}</Link> },
  { header: 'Тел. клиента', render: (o) => o.customer_phone },
  { header: 'Статус заказа', render: (o) => o.status_name },
  { header: 'Сумма для клиента', render: (o) => rub(o.client_order_sum) },
  { header: 'Сумма от поставщика', render: (o) => rub(o.supplier_order_sum) },
  { header: 'Оплачено бонусами', render: (o) => rub(o.bonus_pay) },
];

const PART_COLUMNS: DataColumn<OrderPart>[] = [
  { header: 'ID запчасти', render: (p) => p.id },
  { header: 'Артикул', render: (p) => p.article_name },
  { header: 'Описание', render: (p) => p.description },
  { header: 'Бренд', render: (p) => p.brand_name },
  { header: 'Кол-во', render: (p) => p.quantity },
  { header: 'Цена поставщика', render: (p) => rub(p.distributor_price) },
  { header: 'Цена для клиента', render: (p) => rub(p.customer_price) },
  { header: 'Статус запчасти', render: (p) => p.status },
  { header: 'Поставщик', render: (p) => p.distributor_name },
  { header: 'ID заказа от поставщика', render: (p) => p.distributor_order_id },
];

export const PartsOrderPage = () => {
  const id = useRouteId();
  const order = useQuery({ queryKey: ['parts-order', id], queryFn: () => fetchPartOrder(id) });
  const parts = useQuery({ queryKey: ['parts-order-parts', id], queryFn: () => fetchOrderParts(id) });

  return (
    <DetailLayout
      title="Запчасти"
      isLoading={order.isLoading || parts.isLoading}
      error={order.error ?? parts.error}
    >
      <h3 className="box-title">
        Заказ №{id} <Link to="/parts/parts">Все заказы</Link>
      </h3>
      <DataTable columns={ORDER_COLUMNS} rows={order.data ?? []} rowKey={(o) => o.id} />
      <h3 className="box-title">Заказ:</h3>
      <DataTable columns={PART_COLUMNS} rows={parts.data ?? []} rowKey={(p) => p.id} />
    </DetailLayout>
  );
};
